import React, { lazy } from 'react';
import { type Route, type Routes } from 'react-resource-router';
import { componentWithSuspense } from '../../utils';
import { AppAccessGate } from '../AppAccessGate';

const GraphClawHubPage = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_dtac-graphclaw-hub" */ '../../pages/graphclaw-hub'
		),
);

const GraphClawHubPageWithAccess: React.FC = () => (
	<AppAccessGate appName="Labs">
		<GraphClawHubPage />
	</AppAccessGate>
);

const ROUTE_PREFIX = '/graphclaw-hub' as const;

const graphClawHubRoutesObject: Record<string, Route> = {
	home: {
		name: 'graphclaw-hub',
		path: ROUTE_PREFIX,
		exact: true,
		component: componentWithSuspense(GraphClawHubPageWithAccess),
	},
};

export const graphClawHubRoutes: Routes = Object.values(graphClawHubRoutesObject);
